import React, { useEffect, useState } from "react";
import { IonButton, IonRow, IonCol, IonGrid, IonSpinner } from "@ionic/react";
import EnergyStarTasks from "./EnergyStarTasks";
import { API_URL } from "../../actions/settings";
import { Building } from "../../interfaces/Building";
import EnergyStarDataRequestForm from "./EnergyStarDataRequestForm";
import ConsumptionDataUploadTemplate from "../../pages/Energystar/ConsumptionDataUploadTemplate";
import DegreeDaysLookup from "./DegreeDaysLookup";
import AE2Modal from "../elements/AE2Modal";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import {
  setTaskState,
  selectTask,
  initialState,
} from "../../reducers/TaskReducer";

// interface Props {}

async function getBuildings(token: any) {
  return fetch(`${API_URL}/energystar/customers/buildings`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

async function getRecentInvoiageTask(token: any) {
  return fetch(`${API_URL}/celery_tasks/recent/Import_Invoiage_Bills`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

async function triggerInvoiageTask(token: any) {
  return fetch(`${API_URL}/invoiage/task/trigger`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

async function taskProgress(token: any, id: string) {
  return fetch(`${API_URL}/task_status/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

const EnergyStarData: React.FC = () => {
  const [tab, setTab] = useState("data");
  const [buildings, setBuildings] = useState<Building[] | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [invoiageData, setInvoiageData] = useState<any>(null);
  const [loading, setLoading] = useState(false)  
  const dispatch = useAppDispatch();

  const handleInvoiage = async () => {
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res = await getRecentInvoiageTask(token);
    if(res.status==='success'){
      setInvoiageData(res.data)      
    }
  }
  const handleTriggerInvoiageTask = async () => {
    setLoading(true)
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res = await triggerInvoiageTask(token);
    if(res && res.task){
      checkTaskProgress(res.task)
    }
    else{
      setLoading(false)
    }

  }

  useEffect(() => {
    const handleBuildings = async () => {
      const tkn: any = localStorage.getItem("token");
      const token = `Token ${tkn.slice(1, -1)}`;
      const res = await getBuildings(token);
      setBuildings(res.data);
    };
    handleBuildings();
    handleInvoiage();
    let params = new URLSearchParams(window.location.search);
    const tab = params.get("t");
    if (tab) setTab(tab);
  }, []);


  const checkTaskProgress = async (task_id: string) => {
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const task_res = await taskProgress(token, task_id);
    if (task_res.state === "SUCCESS" || task_res.state === "PENDING" || task_res.state === "STARTED") {
      dispatch(
        setTaskState({
          task_id: task_id,
          status: task_res.state,
          result: {
            progress: 0,
          },
        })
      );

      const interval = setInterval(async () => {
        const task_res = await taskProgress(token, task_id);
        dispatch(
          setTaskState({
            task_id: task_id,
            status: task_res.state,
            result: task_res.details,
          })
        );

        if (task_res.state === "SUCCESS") {
          clearInterval(interval);
          setLoading(false);
          handleInvoiage();
        }
        if (task_res.state === "FAILURE") {          
          dispatch(setTaskState(initialState));
          clearInterval(interval);
          handleInvoiage();
          setLoading(false);
        }
      }, 1000);
    }
    if (task_res.state === "FAILURE") {
      dispatch(setTaskState(initialState));
      handleInvoiage();
      setLoading(false);
    }

    
  };

  return (
    <IonGrid style={{ height: "100%" }}>
      <IonRow style={{ height: "100%" }}>
        <IonCol size="12" sizeMd="1.5">
          <div>
            <IonButton
              color="tertiary"
              expand="block"
              onClick={() => setTab("data")}
            >
              {" "}
              Energy Star Data{" "}
            </IonButton>
          </div>
          <div>
            <IonButton
              color="tertiary"
              expand="block"
              onClick={() => setTab("calculations")}
            >
              {" "}
              A.I. Calculations{" "}
            </IonButton>
          </div>
          <div>
            <IonButton
              color="tertiary"
              expand="block"
              onClick={() => setTab("degree_days_lookup")}
            >
              {" "}
              Lookup Degree Days{" "}
            </IonButton>
          </div>
          {/* <div>
            <IonButton
              color="tertiary"
              expand="block"
              onClick={() => setTab("bills")}
            >
              {" "}
              Upload Bills{" "}
            </IonButton>
          </div> */}
          <div>
            <IonButton
              color="tertiary"
              expand="block"
              onClick={() => setTab("results")}
            >
              {" "}
              Results{" "}
            </IonButton>
          </div>
          <div>
            <IonButton
              color="tertiary"
              expand="block"
              onClick={() => setShowModal(true)}
            >
              {" "}
              Invoiage{" "}
            </IonButton>
          </div>
        </IonCol>
        <IonCol size="12" sizeMd="10.5">
          {tab === "data" || tab === "calculations" ? (
            <div>
              <EnergyStarDataRequestForm tab={tab} buildings={buildings} />
            </div>
          ) : null}
          {tab === "bills" ? <ConsumptionDataUploadTemplate /> : null}
          {tab === "degree_days_lookup" ? <DegreeDaysLookup /> : null}

          {tab === "results" ? (
            <div>
              <EnergyStarTasks />
            </div>
          ) : null}
        </IonCol>
      </IonRow>
      <AE2Modal opened={showModal} setOpened={setShowModal} title="Invoiage Data">
          <div style={{width:'100%', textAlign:'center'}}>
            {invoiageData ?
            <div className="text-white" style={{margin:'1rem'}}> 
              <div> Invoiage data pull was last completed on <span>{new Date(invoiageData.latest_runtime).toLocaleString("en-US")}</span>.</div> 
              <div>Last Status: <span>{invoiageData.task_status}</span></div>
            </div> :
            null }
            <IonButton fill='solid' color="medium" disabled={loading} onClick={()=>handleTriggerInvoiageTask()} > {loading ? <IonSpinner/> : 'Pull Data'}</IonButton>
            
          </div>
          
      </AE2Modal>      
    </IonGrid>
  );
};

export default EnergyStarData;
